import React, { useEffect, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';
import { apiUriProj2Http } from '../../services/conf/apiConf';
import Notification from '@plasma/ui.feedback.notification';

import translations from './i18n';
import { CreateNewProjectProps } from './create-new-project';
import help from './create-new-project.help';

import notification from '@plasma/ui.feedback.notification';
import { sendAllFileByPost } from '../../services/posts/postdata';
import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { headers_custom_func_get, headers_custom_func_set_logoff } from '../../services/Auth/get_set_AuthHeaders';
import { apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useCreateNewProjectHook(props: CreateNewProjectProps) {
  useResourceBundle(translations, undefined, '6a3adc14-cb30-45ed-a1f4-dd16f4951561');
  useHelpBundle(help);

  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState(false);
  const [cName, setCName] = useState('');
  const [pCode, setPCode] = useState('');
  const [remarks, setRemarks] = useState('');
  const [selectedFile, setSelectedFile] = useState<File>();
  const [companyData, setCompanyData] = useState([]);
  const [companySelectedId, setCompanySelectedId] = useState<any>();
  const [capsErrorMessage, setCapsErrorMessage] = useState("");

  useEffect(() => {
    fetchAllDataGet_byApiName('GetMasterCompanies', apiUriMasterDataHttp())
      .then((data) => {
        setCompanyData(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch companies');
      });
  }, []);



  const addForm = () => {
    setInputValue(true);
  };
  const changeName = (e) => {
    setCName(e.target.value);
  };

  const changePCode = (e) => {
    const inputValue = e.target.value;
    const filteredValue = inputValue.replace(/[^a-z0-9]/g, '');

  if (/^\d/.test(filteredValue) || filteredValue==='') {
    setCapsErrorMessage(" lowercase alphabets only...");
    setPCode('');
  } else {
    setPCode(filteredValue);
    setCapsErrorMessage('');
  }
  };

  const changeRemarks = (e) => {
    setRemarks(e.target.value);
  };

  const handleSubmit = async () => {

    const DataToSend = {
      companyname: cName,
      plantcodename: pCode,
      schemaname: pCode,
      remarks: remarks,
      isactive: true,
    };

    try {
      const response = await fetch(apiUriProj2Http() + 'createNewProject', {
        method: 'POST',
        headers: headers_custom_func_get(),
        body: JSON.stringify(DataToSend),
      });

      if (!response.ok) {
        if (response.status === 401) {
          console.log('UNAUTHORIZED');
        }
        throw new Error(`Failed to fetch data`);
      } else {
        const resposiveData: any = await response.json();
        console.log('data send successfully', resposiveData.code);
        if (resposiveData.message === 'Success') {
          Notification.success(t("success"), t("create-success"));
          handleReset();
          fetchAllDataGet_byApiName('GetMasterCompanies', apiUriMasterDataHttp())
            .then((data) => {
              setCompanyData(data);
            })
            .catch((error) => {
              console.log('Failed to Fetch companies');
            });
        }
        if (resposiveData.message === 'Failed') {
          // The API's reason (e.g. "Schema appx already exists in the database."), else the generic text
          Notification.error(t("failed"), resposiveData.responseData || `${t("could-not-crete")}, ${t("already-exist")}`);
        }
        // return data.responseData;
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  const handleReset = async () => {
    setCName('');
    setPCode('');
    setRemarks('');
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ['image/*'];
    if (file) {
      setSelectedFile(file);
    } else {
      event.target.value = ''; // Clear the input field
      alert('Please Select A Image File.'); // Show an error message
    }
  };

  const handleFileUploadButton = () => {
    //console.log(selectedFile);
    const formData = new FormData();
    if (selectedFile) {
      //console.log(selectedFile);
      formData.append('File', selectedFile);
      //console.log('Data to send: ', formData);

      sendAllFileByPost('uploadLogo', formData)
        .then((response) => {
          //console.log('API Response: ', response);
          notification.success(t("success"), t('logo-saved-successfully'), undefined, 'medium', 1);
        })
        .catch((error) => {
          console.log(error);
          notification.error(t("failed"), t("could-not-save"), undefined, 'medium', 1);
        });
    }
  };

  console.log('selected id: ', companySelectedId);

  const handleTargetCompanySubmit = () => {
    headers_custom_func_set_logoff();
    sessionStorage.setItem('companyID', companySelectedId);
    window.location.reload();
  };

  const isButtonEnabled = cName.trim() !== '' && pCode.trim() !== '';//&& sName.trim() !== '';

  return {
    t,
    inputValue,
    setInputValue,
    addForm,
    cName,
    pCode,
    remarks,
    changeName,
    changePCode,
    changeRemarks,
    handleSubmit,
    handleReset,
    handleFileChange,
    handleFileUploadButton,
    isButtonEnabled,
    companyData,
    companySelectedId,
    setCompanySelectedId,
    handleTargetCompanySubmit,
    capsErrorMessage
  };
}

export default useCreateNewProjectHook;
